import React from "react";
import { useLocation } from "react-router-dom";
import styles from './header.module.css';
import Logo from "../logo/logo";
import { SHOP_NAME, PHONE_NUMBERS } from "../../utils/constants";
import { useSelector } from "react-redux";
import Navbar from "../navbar/navbar";

import { getPathParams } from "../../services/selectors";
import Breadcrumbs from "../bread_crumbs/bread_crumbs";


function Header() {

  const location = useLocation();

  const { uid } = useSelector(getPathParams);

  return (
    <header className={styles.header}>
      <div className={`${styles.upper_block}`}>
        <Logo />
        <h2 className={`${styles.upper_name}`}>
          {SHOP_NAME}
        </h2>
        <div className={`${styles.telContainer}`}>
          <a href={PHONE_NUMBERS[0].link} className={`${styles.telNum}`}>
            {PHONE_NUMBERS[0].number}
          </a>
        </div>
      </div>
      <div className={`${styles.medium_block}`}>
        <h2 className={`${styles.medium_name}`}>
          {SHOP_NAME}
        </h2>

      </div>
      <div className={styles.lowerBlock}>
        <Navbar />
        {location.pathname !== '/' && <Breadcrumbs onlyEnd={uid} />}
      </div>
    </header>
  );
}

export default Header;
